import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7906767a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-area" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 아직 고민된다면")
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 환급 조회만 해보세요. ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 무료로 신청하고 더낸세금 돌려 받으세요 ")
const _hoisted_6 = ["src"]

import { ref, onMounted } from 'vue'

import Text from '@/components/common/TextComponent.vue'
import Button from '@/components/common/Button.vue'
import { FONT_WEIGHT, COLOR_SET } from '@/styles/variables'
import { getImageUrl } from '@/utils/getImageUrl'
import toRefund from '@/utils/toRefund'

import { setAnimationObserver } from '../libs/observer'


export default /*#__PURE__*/_defineComponent({
  name: 'LandingBanner',
  setup(__props) {

const wrapper = ref()
const showAnimation = ref(false)

onMounted(() => {
  setAnimationObserver(wrapper.value, () => { showAnimation.value = true }, 0.2)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "wrapper",
    ref: wrapper,
    class: _normalizeClass(["wrapper animation-wide", { show: showAnimation.value }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(Text, {
        color: _unref(COLOR_SET).white,
        weight: _unref(FONT_WEIGHT).bold,
        size: "64px",
        "mobile-size": "30px",
        "text-align": "center"
      }, {
        default: _withCtx(() => [
          _hoisted_2,
          _hoisted_3,
          _hoisted_4
        ]),
        _: 1
      }, 8, ["color", "weight"]),
      _createVNode(Text, {
        color: _unref(COLOR_SET).white,
        margin: "12px 0 60px 0",
        "mobile-size": "14px",
        "mobile-margin": "12px 0 0 0"
      }, {
        default: _withCtx(() => [
          _hoisted_5
        ]),
        _: 1
      }, 8, ["color"]),
      _createVNode(Button, {
        class: "button",
        text: "환급 조회하기",
        weight: "700",
        "font-size": "20px",
        width: "327px",
        height: "60px",
        onButton_click: _unref(toRefund)
      }, null, 8, ["onButton_click"])
    ]),
    _createElementVNode("img", {
      src: _unref(getImageUrl)('landing/banner.png')
    }, null, 8, _hoisted_6)
  ], 2))
}
}

})